import React from "react";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";

// jaza
import { List, TextField, FunctionField, Datagrid, CreateButton, DeleteButton, ShowButton } from "jazasoft";
// helper
import hasPrivilege from "../../../utils/hasPrivilege";

import { ResourceId, Scope } from "../../../utils/privilege";
import { isTrue } from "../../../utils/helpers";

const useStyles = makeStyles(theme => ({
  buttonEdit: {
    width: theme.spacing(14),
  },
  buttonDelete: {
    width: theme.spacing(16),
  },
}));

const ApiKey = props => {
  const classes = useStyles();
  const { roles, hasAccess } = props;

  return (
    <List
      actions={({ basePath, roles, hasAccess }) => (
        <div>
          {hasPrivilege(roles, hasAccess, ResourceId.API_KEY, Scope.WRITE) && (
            <CreateButton basePath={basePath} showLabel={false} />
          )}
        </div>
      )}
      {...props}>
      <Datagrid className={classes.datagrid}>
        <TextField label="App Id" source="appId" />
        <FunctionField source="active" render={record => (isTrue(record?.active) ? "Yes" : "No")} />
        <ShowButton cellClassName={classes.buttonEdit} />
        {hasPrivilege(roles, hasAccess, ResourceId.API_KEY, Scope.DELETE) && (
          <DeleteButton cellClassName={classes.buttonEdit} />
        )}
      </Datagrid>
    </List>
  );
};

export default ApiKey;
